<script lang="ts">
    import type {ErrorGridFieldValue} from 'src/features/record-grid/lib/types';

    export let value: ErrorGridFieldValue;
</script>

<span>{value.text}</span>
<span class="kp-grid-field-error">({value.error.text})</span>

<style lang="less">
    .kp-grid-field-error {
        color: red;
        font-size: 0.8em;
    }
</style>
